import { ParameterSetDetailDto, ParameterSetEditDto } from './parameterset';

export const mapParameterSetDetailToEdit = (
  dto: ParameterSetDetailDto
): ParameterSetEditDto => ({
  id: dto.id,
  no: dto.no,
  name: dto.name,
  text: dto.text,
  private: dto.private,
  parameterSetTypeId: dto.parameterSetTypeId,
  parameterSetParameters: dto.parameterSetParameters
});
